<template>
  <Modal v-model="batchImportOrdersModal" :title="$t('key1006172')" :transfer="false" :mask-closable="false" :width="700"
    @on-visible-change="batchImportOrdersChange">
    <Form ref="batchImportOrdersForm" :model="batchImportOrdersForm" :label-width="labelWidth" @submit.native.prevent>
      <Row align="middle" justify="space-between">
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1002436')" prop="ymsPackageInfoImportTempId" class="required_style_label">
            <Select filterable style="width:300px;" v-model="batchImportOrdersForm.ymsPackageInfoImportTempId">
              <Option v-for="item in ymsPackageInfoImportTempList" :key="item.ymsPackageInfoImportTempId" :value="item.ymsPackageInfoImportTempId">{{ item.name }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1006169')" prop="sourceRemark">
            <Input v-model.trim="batchImportOrdersForm.sourceRemark" :maxlength="50" style="width:300px;" :placeholder="$t('key1006305')"/>
          </Form-item>
        </Col>
        <Col span="24" class="no_margin_style mb10">
          <Form-item :label="$t('key1000262')" prop="file" class="required_style_label">
            <div class="flex align-items-center">
              <Upload
                style="display: inline-block"
                :headers="headObj"
                ref="uploadRef"
                name='files'
                :data="uploadData"
                :show-upload-list="false"
                :action="uploadAction"
                :before-upload="beforeHandleUpload"
                :on-success="uploadSuccess"
                :on-error="uploadError"
                :max-size="uploadFilesMaxSize"
                :format="importFormat">
                <Button class="mr10">
                  <i class="iconfont">&#xe664;</i>
                  {{ $t('key1000266') }}
                </Button>
              </Upload>
            </div>
          </Form-item>
        </Col>
        <Col span="24" class="no_margin_style mb10" v-if="excleFile">
          <Form-item :label="$t('key1000334')">
            <span>{{ excleFile.name }}</span>
          </Form-item>
        </Col>
        <Col span="24" push="2">
          <div class="tips_styles">
            {{ $t('key1000270') }}<br/>
            {{ $t('key1006310') }}<br/>
            {{ $t('key1006311') }}<br/>
            {{ $t('key1006312') }}<br/>
            {{$t('key1006306')+ configCharacters() + $t('key1006307')}}<br/>
            {{ $t('key1006308') + configCharacters() + $t('key1006309')}}
          </div>
        </Col>
      </Row>
    </Form>
    <template #footer>
      <Button @click="batchImportOrdersModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" :disabled="!(batchImportOrdersForm.ymsPackageInfoImportTempId && excleFile)"
        @click="batchImportOrdersBtn">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';

export default {
  name: 'batchImportOrdersModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      batchImportOrdersModal: false,
      batchImportOrdersForm: {
        ymsPackageInfoImportTempId: null,
        sourceRemark: '',
      },
      ymsPackageInfoImportTempList: [],
      uploadData: {},
      uploadAction: api.post_ymsDistributorPackageInfo_excelImport,
      importFormat: ['xls', 'xlsx'],
      excleFile: null,
      formatError: false,
    };
  },
  computed: {},
  created() {

  },
  methods: {
    // 初始化数据
    initBatchImportOrdersData() {
      this.axios.get(api.get_ymsPackageInfoImportTemp_queryList).then((response) => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          this.ymsPackageInfoImportTempList = data || [];
        }
        this.batchImportOrdersModal = true;
      });
    },
    // 确定按钮
    batchImportOrdersBtn() {
      let v = this;
      let sourceRemark = v.batchImportOrdersForm.sourceRemark;
      if (v.excleFile) {
        if (sourceRemark) {
          let reg = v.$regular.MatchEnglish;
          if (reg.test(sourceRemark)) {
            handleData();
          } else {
            v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006303'));
            return false;
          }
        } else {
          handleData();
        }
      } else {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000254'));
        return false;
      }

      function handleData() {
        v.$set(v.$refs['uploadRef'].data, 'ymsPackageInfoImportTempId', v.batchImportOrdersForm.ymsPackageInfoImportTempId);
        v.$set(v.$refs['uploadRef'].data, 'sourceRemark', v.batchImportOrdersForm.sourceRemark);
        v.$refs['uploadRef'].post(v.excleFile); // 手动上传
        if (!v.formatError) {
          setTimeout(() => {
            v.excleFile = null;
            v.importBackupOrderModal = false;
          }, 2000);
        }
      }
    },
    // 上传文件成功
    uploadSuccess(res, file, fileList) {
      let v = this;
      let code = res.code;
      if (code === 0) {
        v.batchImportOrdersModal = false;
        v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155'));
        setTimeout(() => {
          v.$emit('updateData', true);
        }, 1000);
      }
    },
    // 上传文件之前
    beforeHandleUpload(excleFile) {
      let obj = {};
      let v = this;
      // 校验图片大小不能大于20M
      const maxSize = 20 * 1024 * 1024;
      const fileExtension = excleFile.name.split('.').pop().toLowerCase();
      if (!v.importFormat.includes(fileExtension)) {
        this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006304'));
        return false;
      } else if (excleFile.size > maxSize) {
        this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001466'));
        return false;
      } else {
        v.excleFile = excleFile;
        obj.ymsPackageInfoImportTempId = v.batchImportOrdersForm.ymsPackageInfoImportTempId;
        obj.sourceRemark = v.batchImportOrdersForm.sourceRemark;
        v.uploadData = Object.assign({}, obj);
        return false;
      }
    },
    // 上传文件失败
    uploadError() {
      this.formatError = true;
      this.batchImportOrdersModal = true;
      this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000250'));
      return false;
    },
    // 监听弹窗
    batchImportOrdersChange(value) {
      if (!value) {
        this.excleFile = null;
        this.formatError = null;
        this.$refs['batchImportOrdersForm'].resetFields();
      }
    }
  }
};
</script>

<style lang="less" scoped>
.no_margin_style {
  /deep/ .ivu-form-item {
    margin: 0 !important;
  }
}

.tips_styles {
  color: #9a9797;
  margin: 12px 0 20px 0;
}
</style>
